///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// duplicated from utils because utils might not be loaded when this is first needed
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// override default searchanize "add to cart" feature
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function OverrideSnizeATCButtons( container )
{
    var buttons = container.querySelectorAll( "li.snize-product button" );
    buttons.forEach( function( button )
    {
        var li      = SearchParentsFor( button, "snize-product" );
        var swapped = false;
        var qtyDiv  = undefined;
        
        if ( li )
        {
            var idstr = li.getAttribute( "id" );
            if ( ( idstr ) && ( idstr.startsWith( "snize-product-" ) ) )
            {
                var id       = idstr.substr( 14 );
                var cartItem = document.querySelector( ".cart-drawer__content .products-in-cart[data-product-id='" + id + "'] .cart-quantity" );
                
                if ( cartItem )
                {
                    qtyDiv = li.querySelector( ".cart-quantity" );
                    if ( qtyDiv )
                    {
                        if ( window.isBasketChanging )
                        {
                            // don't update the value if the basket is being updated - otherwise it flicks to the old value for a second
                        }
                        else
                        {
                            qtyDiv.querySelector( "input" ).value = cartItem.querySelector( "input" ).value; // update value
                        }
                    }
                    else
                    {
                        // make a copy of the quantity controls in the sidecart and drop next to the default "add to cart" button
                        var anchors = cartItem.querySelectorAll( "a" );
                        for( var i = 0; i < anchors.length; i++ )
                        {
                            var anchor = anchors[ i ];
                            if (anchor.classList.contains("cart-quantity-value-unchangeable")) {
                                var updatedAnchor = $(anchor).removeClass("cart-quantity-value-unchangeable");
                                $( cartItem ).find ( $ ( anchor ) ).replaceWith( $( updatedAnchor ) );
                            }
                        }
                        qtyDiv = cartItem.cloneNode( true );
                        button.parentNode.appendChild( qtyDiv );
                    }
                    
                    swapped = true;
                }
            }
        }

        if ( swapped )
        {
            button.setAttribute( "style", "display: none;" );
            if ( qtyDiv )
            {
                qtyDiv.removeAttribute( "style" );
              	
                if( !qtyDiv.getAttribute( "data-listener-added" ) )
                {
                	HandleSnizeQtyBtns( qtyDiv ); 
                  	qtyDiv.setAttribute( "data-listener-added", "true" );
                }
            }
        }
        else
        {
            button.removeAttribute( "style" );
            if ( qtyDiv )
            {
                qtyDiv.setAttribute( "style", "display: none;" );
            }
        }
    } );
}
function StartupSearchanizeOverride( )
{
    console.log( "checking for snize override" );
    var container = document.getElementById( "snize_results" );
    if ( container )
    {
        console.log( "starting snize override" );

        OverrideSnizeATCButtons( document.body );

        /*var observer = new MutationObserver( function( ml, o )
        {
            observer.takeRecords( );
            observer.disconnect( );
            
            OverrideSnizeATCButtons( document.body );

            observer.observe( document.body, { "childList": true, "subtree" : true } );
        } );
        observer.observe( document.body, { "childList": true, "subtree" : true } );*/
    }
}
StartupSearchanizeOverride( );

function HandleSnizeQtyBtns( qtyDiv )
{
    var anchors = qtyDiv.querySelectorAll( "a" );
    for( var i = 0; i < anchors.length; i++ )
    {
        var anchor = anchors[ i ];
        // $( anchor ).on( "click", function( e )
        // {
        //     console.log( e );
        //     e.preventDefault();
        //     //cartProductQty( e.currentTarget );
        // } );
    }
  
    var input = qtyDiv.querySelector( ".cart-quantity-value" );
    input.addEventListener( "ontouchstart", function( e )
    {
        e.preventDefault();
        e.stopPropagation();        
    } );
  
    input.addEventListener( "click", function( e )
    {
        e.preventDefault();
        e.stopPropagation();        
    } );
  
    input.addEventListener( "ontouchend", function( e )
    {
        e.reload();    
    } );
}

function AddListenerToSnizeQtyBtn( snizeBtn )
{
	$( snizeBtn ).on( "click", function( e )
    {
    	console.log( e );
    	e.preventDefault();
  	} );
  	snizeBtn.setAttribute( "data-listener-added", "true" );
}

window.addEventListener( "load", function()
{
  // 	var snizeQtyBtns = document.querySelectorAll( ".cart-quantity" );
  // 	console.log( snizeQtyBtns );
  // 	if( snizeQtyBtns && snizeQtyBtns.length > 0 )
  //   {
		// for( var i = 0; i < snizeQtyBtns.length; i++ )
  //       {
  //        	var snizeBtn = snizeQtyBtns[ i ] ;
  //         	if( !snizeBtn.getAttribute( "data-listener-added" ) )
  //           {
  //             	AddListenerToSnizeQtyBtn( snizeBtn ); 
  //           }
  //       }
  //   }
    var snizeViewProductBtns = document.querySelectorAll( ".snize-view-product-button" );
    if( snizeViewProductBtns && snizeViewProductBtns.length > 0 )
    {
		for( var i = 0; i < snizeViewProductBtns.length; i++ )
        {
         	var snizeViewProductBtn = snizeViewProductBtns[ i ] ;
          	
             $(snizeViewProductBtn).html('Out of stock');
        }
    }
    
    $('.cart-quantity.cart-product-details-styling').click(function (e) { 
        e.preventDefault();
        return false;
    });
    
} );


if (document.querySelector(".cart-quantity-value")){
    document.querySelector(".cart-quantity-value").addEventListener("click", function(event){
    event.preventDefault();
    event.stopPropagation();
    });
}


